import { useQuery } from '@tanstack/react-query';

import { getApiClient } from '@aslanpay/portal-common-lib';

import { CompanyDeductionsReportStatus } from 'app/constants/deductionsReports';

import { DeductionsReportErrorsResponse } from './types';

export const DEDUCTIONS_REPORT_ERRORS_QUERY_KEY = 'fetchDeductionsReportErrors';

/**
 * Lists the errors and warnings recorded against a company deductions report's current attempt. The report's status is
 * part of the key, so a retry that changes it reads them again.
 */
const useFetchDeductionsReportErrors = (
  id?: string,
  status?: CompanyDeductionsReportStatus,
  enabled = true
) =>
  useQuery<DeductionsReportErrorsResponse, Error>(
    [DEDUCTIONS_REPORT_ERRORS_QUERY_KEY, id, status],
    async () => {
      const { data } = await getApiClient().get<DeductionsReportErrorsResponse>(
        `/reports-service/deductions-reports/${id}/errors`
      );
      return data;
    },
    { enabled: enabled && !!id }
  );

export default useFetchDeductionsReportErrors;
